import React, { useEffect, useState } from 'react';
import { Modal, TextInput } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';

import useUpdateAttachment from '../hooks/useUpdateAttachment';

export default function EditAttachmentModal({
  isModalOpen,
  setIsModalOpen,
  selectedAttachment,
  taskId,
}) {
  const [inputValue, setInputValue] = useState('');

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const updateAttachemntMutation = useUpdateAttachment(closeModal, taskId);

  useEffect(() => {
    setInputValue(selectedAttachment?.file_name);
  }, [selectedAttachment]);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateAttachemntMutation.mutate({
      id: selectedAttachment?.id,
      task_id: taskId,
      file_name: inputValue,
    });
  };

  return (
    <Modal
      opened={isModalOpen}
      onClose={() => closeModal(false)}
      title={'Edit an attachment'}
      withCloseButton={false}
      overlayColor={'#F8F7F799'}
      overlayBlur={20}
      overlayOpacity={0.5}
      centered
      size='lg'
      radius='md'
      overflow='inside'
      transitionDuration={100}
      classNames={{
        title: 'w-full text-333333 font-semibold text-xl text-center',
        modal: 'pl-10',
        body: 'scroller -mr-4 pr-2',
      }}
    >
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className='mr-8'>
          <TextInput
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            label='Text to display'
            classNames={{
              input: 'py-5',
            }}
          />
          <div className='flex justify-center space-x-7 mt-10 mb-4'>
            <button className='w-32' disabled={!inputValue?.length}>
              <PrimaryButton isLoading={updateAttachemntMutation?.isLoading}>
                Save
              </PrimaryButton>
            </button>
            <button className='w-32' onClick={() => closeModal()}>
              <SecondaryButton>Cancel</SecondaryButton>
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
